module.exports = __webpack_public_path__ + "media/applicants/expand-fc8b988f.svg";